import React, {useEffect, useState} from 'react'
import {Form, Select, Button, Row, Col} from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import {toast} from 'react-toastify'

const {Option} = Select

const AssignUserForm = props => {
  const {form, assignID, onSuccess, modalVisible} = props
  const {getFieldDecorator} = form
  const [loading, setLoading] = useState(false)
  const [roles, setRoles] = useState([])
  const [users, setUsers] = useState([])
  const [parents, setParents] = useState([])

  useEffect(() => {
    fetchRoles()
    if (assignID) {
      fetchAssignDetails(assignID)
    } else {
      form.resetFields()
    }
  }, [assignID, modalVisible])

  const fetchRoles = async () => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/getAllRoles`,
        'GET',
      )
      setRoles(res?.data || [])
    } catch (err) {
      console.error('Error fetching roles:', err)
    }
  }

  const fetchUsersAndParentsByRole = async roleId => {
    try {
      // Fetch users
      const userRes = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/getAllUsersByRole/${roleId}`,
        'GET',
      )
      setUsers(userRes?.data || [])
      form.setFieldsValue({userId: undefined})

      // Fetch parents
      const parentRes = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/parent-role-users/${roleId}`,
        'GET',
      )
      setParents(parentRes?.data || [])
      form.setFieldsValue({parentId: undefined})
    } catch (err) {
      console.error('Error fetching users/parents by role:', err)
    }
  }

  const fetchAssignDetails = async id => {
    try {
      const res = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/api/AssignUser/get/${id}`,
        'GET',
      )
      if (res.success) {
        const {roleId, userId, parentId} = res.data
        await fetchUsersAndParentsByRole(roleId)
        form.setFieldsValue({roleId, userIds: [userId], parentId})
      }
    } catch (err) {
      console.error('Error fetching assign details:', err)
    }
  }

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)
      const payload = {...values}
      const url = assignID
        ? // ? `${process.env.REACT_APP_BASE_URL_ADMIN}/api/Auth/${assignID}`
          `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/${assignID}`
        : `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/assign-parent-to-users`
        // : `${process.env.REACT_APP_BASE_URL_ADMIN}/api/Auth/add`
      try {
        const res = await apiRequest(url, 'POST', payload)
        if (res.success) {
          toast.success(
            assignID
              ? 'Assignment updated successfully'
              : 'Assignment created successfully',
          )
          if (onSuccess) onSuccess()
        } else {
          toast.error(res.error)
        }
      } catch (err) {
        toast.error('Something went wrong!')
      } finally {
        setLoading(false)
      }
    })
  }

  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={8}>
              <Form.Item label="Select Role">
                {getFieldDecorator('roleId', {
                  rules: [{required: true, message: 'Please select a role'}],
                })(
                  <Select
                    placeholder="Select Role"
                    onChange={fetchUsersAndParentsByRole}>
                    {roles.map(role => (
                      <Option key={role?.roleId} value={role?.roleId}>
                        {role?.roleName}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Select Users">
                {getFieldDecorator('userIds', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select at least one user',
                    },
                  ],
                })(
                  <Select placeholder="Select Users" mode="multiple" allowClear>
                    {users.map(user => (
                      <Option key={user?.id} value={user?.id}>
                        {`${user?.firstName} ${user?.lastName}`}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={8}>
              <Form.Item label="Select Parent">
                {getFieldDecorator('parentId', {
                  rules: [{required: true, message: 'Please select a parent'}],
                })(
                  <Select placeholder="Select Parent">
                    {parents.map(parent => (
                      <Option key={parent?.id} value={parent?.id}>
                        {`${parent?.firstName} ${parent?.lastName}`}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className="btn-success">
              {assignID ? 'Update Assignment' : 'Add Assignment'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(AssignUserForm)
